import { Box, Button } from '@mui/material';
import DialogBody from 'components/dialog/DialogBody';
import DialogButtons from 'components/dialog/DialogButtons';
import DialogContent from 'components/dialog/DialogContent';
import DialogTitle from 'components/dialog/DialogTitle';
import { memo } from 'react';
import { useAppDispatch } from 'store';
import { closeDialog } from 'store/dialog/dialogSlice';

interface IFileUploadDialogProps {
  contents: string;
  title?: string;
  handleButtonClick: (action: string) => void;
}
function FileUploadDialog({ title = '', contents, handleButtonClick }: IFileUploadDialogProps): JSX.Element {
  const dispatch = useAppDispatch();
  const handleClick = (type: string) => {
    handleButtonClick(type);
    dispatch(closeDialog());
  };
  return (
    <DialogContent width={{ desktop: 500 }} height={{ desktop: 'fit-content' }}>
      {title && <DialogTitle>{title}</DialogTitle>}
      <DialogBody style={{ overflowX: 'hidden', overflowY: 'scroll !important' }}>
        <Box sx={{ fontSize: 18, fontWeight: 700, mb: 3 }}>{contents}</Box>
      </DialogBody>
      <DialogButtons justifyContent="space-evenly" marginTop="0px">
        <Button variant="contained" onClick={() => handleClick('add')}>
          기존 데이터에 추가
        </Button>
        <Button variant="outlined" onClick={() => handleClick('new')}>
          기존 데이터 삭제 후 새로 추가
        </Button>
      </DialogButtons>
    </DialogContent>
  );
}

export default memo(FileUploadDialog);
